<template>
  <div class="version-list-page">
    <enfold>
      <enfold-cd>
        <template slot="center">
          <div class="layout-container">
            <div class="header-bar">
              <el-button size="small" round icon="el-icon-back" @click="goBack">返回</el-button>
              <span class="page-title">测试版本配置</span>
              <el-button type="primary" size="small" round icon="el-icon-plus" @click="openVersionForm()">添加版本</el-button>
            </div>

            <div class="table-wrapper">
              <el-table :data="versionList" style="width: 100%" height="100%" border v-loading="loading" size="small">
                <el-table-column prop="model" label="设备型号"></el-table-column>
                <el-table-column prop="version" label="版本号" ></el-table-column>
                <el-table-column prop="mcuV" label="MCU版本" ></el-table-column>
                <el-table-column prop="videoV" label="视频处理版本" ></el-table-column>
                <el-table-column prop="cardV" label="发送卡版本" ></el-table-column>
                <el-table-column prop="language" label="语言">
                  <template slot-scope="scope">{{ scope.row.language === 'en' ? 'English' : '中文' }}</template>
                </el-table-column>
                <el-table-column label="自动测试项" >
                  <template slot-scope="scope">
                    <el-tag size="mini" type="info">{{ (scope.row.autoTestKeys || []).length }} / {{ AUTO_TEST_ITEMS.length }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="手动测试项" >
                  <template slot-scope="scope">
                    <el-tag size="mini" type="info">{{ (scope.row.manualTestKeys || []).length }} / {{ MANUAL_TEST_ITEMS.length }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="openVersionForm(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" style="color: #f56c6c" @click="handleVersionDel(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </template>
      </enfold-cd>
    </enfold>

    <!-- 设置/编辑 测试版本弹窗 -->
    <el-dialog :title="versionForm.isEdit ? '编辑测试版本' : '设置测试版本'" :visible.sync="versionFormVisible" width="1000px"
      append-to-body destroy-on-close :close-on-click-modal="false" custom-class="version-form-dialog">
      <el-form ref="versionFormRef" :model="versionForm" :rules="versionRules" label-width="120px" class="version-form">
        <div class="form-split">
          <div class="form-left">
            <el-form-item label="设备型号" prop="model">
              <el-input v-model="versionForm.model" :disabled="versionForm.isEdit" placeholder="如 KU1"></el-input>
            </el-form-item>
            <el-form-item label="版本号" prop="version">
              <el-input v-model="versionForm.version"></el-input>
            </el-form-item>
            <el-form-item label="MCU版本" prop="mcuV">
              <el-input v-model="versionForm.mcuV"></el-input>
            </el-form-item>
            <el-form-item label="视频处理版本" prop="videoV">
              <el-input v-model="versionForm.videoV"></el-input>
            </el-form-item>
            <el-form-item label="发送卡版本" prop="cardV">
              <el-input v-model="versionForm.cardV"></el-input>
            </el-form-item>
            <el-form-item label="系统语言" prop="language">
              <el-select v-model="versionForm.language" placeholder="请选择" style="width: 100%">
                <el-option label="中文" value="zh"></el-option>
                <el-option label="English" value="en"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运行内存" prop="ram">
              <el-select v-model="versionForm.ram" placeholder="请选择" style="width: 100%">
                <el-option label="1GB" value="1GB"></el-option>
                <el-option label="2GB" value="2GB"></el-option>
                <el-option label="4GB" value="4GB"></el-option>
                <el-option label="8GB" value="8GB"></el-option>
                <el-option label="16GB" value="16GB"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="可用空间" prop="rom">
              <el-select v-model="versionForm.rom" placeholder="请选择" style="width: 100%">
                <el-option label="8GB" value="8GB"></el-option>
                <el-option label="16GB" value="16GB"></el-option>
                <el-option label="32GB" value="32GB"></el-option>
                <el-option label="64GB" value="64GB"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form-right">
            <el-form-item label="自动测试项">
              <div class="test-items-group">
                <el-checkbox :indeterminate="isAutoIndeterminate" v-model="autoCheckAll" @change="handleAutoCheckAll">全选</el-checkbox>
                <el-checkbox-group v-model="versionForm.autoTestKeys" @change="handleAutoCheckChange" class="checkbox-list">
                  <el-checkbox v-for="item in AUTO_TEST_ITEMS" :key="item.key" :label="item.key"
                    :disabled="isAutoItemDisabled(item.key)">{{ item.name }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
            <el-form-item label="手动测试项">
              <div class="test-items-group">
                <el-checkbox :indeterminate="isManualIndeterminate" v-model="manualCheckAll" @change="handleManualCheckAll">全选</el-checkbox>
                <el-checkbox-group v-model="versionForm.manualTestKeys" @change="handleManualCheckChange" class="checkbox-list">
                  <el-checkbox v-for="item in MANUAL_TEST_ITEMS" :key="item.key" :label="item.key">{{ item.title }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <template slot="footer">
        <el-button @click="versionFormVisible = false">取消</el-button>
        <el-button type="primary" @click="submitVersionForm">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import enfold from "@/components/basics/Enfold";
import EnfoldCd from "@/components/basics/EnfoldCD";

// 自动测试项目录（与 factoryTesting/src/renderer/config/testItems.ts 保持一致）
const AUTO_TEST_ITEMS = [
  { key: "sn", name: "序列号" },
  { key: "version", name: "设备版本号" },
  { key: "name", name: "设备名称" },
  { key: "wifiName", name: "WiFI名称" },
  { key: "wifiPass", name: "WiFI密码" },
  { key: "wifiIsOpen", name: "WiFI已开启" },
  { key: "cardV", name: "发送卡版本号" },
  { key: "videoV", name: "视频处理版本号" },
  { key: "mcuV", name: "MCU版本" },
  { key: "nMac", name: "有线网mac地址" },
  { key: "wMac", name: "WiFimac地址" },
  { key: "btMac", name: "蓝牙mac地址" },
  { key: "apMac", name: "热点mac地址" },
  { key: "WiFiList", name: "WiFi搜索" },
  { key: "RAM", name: "运行内存" },
  { key: "ROM", name: "可用空间" },
  { key: "bright", name: "亮度" },
  { key: "cpuTemp", name: "温度" },
  { key: "language", name: "系统语言" },
];

// 手动测试项目录
const MANUAL_TEST_ITEMS = [
  { key: "lanOutput", title: "网口输出测试" },
  { key: "hdmiOutput", title: "HDMI输出测试" },
  { key: "usb", title: "USB接口测试" },
  { key: "audio", title: "音频口输出测试" },
  { key: "hdmiIn", title: "HDMI IN输入测试" },
  { key: "hdmiLoop", title: "HDMI LOOP输入测试" },
  { key: "relay", title: "继电器测试" },
];

export default {
  name: "VersionList",
  components: {
    enfold,
    EnfoldCd,
  },
  data() {
    return {
      AUTO_TEST_ITEMS,
      MANUAL_TEST_ITEMS,
      loading: false,
      versionList: [],
      versionFormVisible: false,
      versionForm: {
        isEdit: false,
        _id: "",
        model: "",
        version: "",
        cardV: "",
        videoV: "",
        mcuV: "",
        language: "zh",
        ram: "2GB",
        rom: "16GB",
        autoTestKeys: [],
        manualTestKeys: [],
      },
      versionRules: {
        model: [{ required: true, message: "值不能为空", trigger: "blur" }],
        version: [{ required: true, message: "值不能为空", trigger: "blur" }],
      },
      autoCheckAll: false,
      isAutoIndeterminate: false,
      manualCheckAll: false,
      isManualIndeterminate: false,
    };
  },
  created() {
    this.loadVersionList();
  },
  watch: {
    "versionForm.mcuV"() {
      this.syncAutoTestKeysByVersion();
    },
    "versionForm.videoV"() {
      this.syncAutoTestKeysByVersion();
    },
    "versionForm.cardV"() {
      this.syncAutoTestKeysByVersion();
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: "TestTecords" });
    },
    loadVersionList() {
      this.loading = true;
      this.$http.post("/admin/testRecords/versionList", {}, (data) => {
        const list = (data && data.list) || [];
        // 兼容 autoTestKeys / manualTestKeys 可能是 JSON 字符串的情况
        list.forEach((item) => {
          item.autoTestKeys = this.parseKeys(item.autoTestKeys);
          item.manualTestKeys = this.parseKeys(item.manualTestKeys);
        });
        console.log("versionList 回读数据:", JSON.parse(JSON.stringify(list)));
        this.versionList = list;
        this.loading = false;
      });
    },
    parseKeys(val) {
      if (Array.isArray(val)) return val;
      if (typeof val === "string" && val) {
        try {
          const parsed = JSON.parse(val);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }
      return [];
    },
    // 版本字段为空时，对应的自动测试项不允许勾选
    isAutoItemDisabled(key) {
      if (key === "mcuV") return !this.versionForm.mcuV;
      if (key === "videoV") return !this.versionForm.videoV;
      if (key === "cardV") return !this.versionForm.cardV;
      return false;
    },
    // 当 mcuV/videoV/cardV 为空时移除对应 key，非空时自动勾选对应 key
    syncAutoTestKeysByVersion() {
      const keys = this.versionForm.autoTestKeys.slice();
      let changed = false;
      ["mcuV", "videoV", "cardV"].forEach((key) => {
        const has = keys.includes(key);
        if (this.versionForm[key]) {
          if (!has) {
            keys.push(key);
            changed = true;
          }
        } else if (has) {
          keys.splice(keys.indexOf(key), 1);
          changed = true;
        }
      });
      if (changed) {
        this.versionForm.autoTestKeys = keys;
        this.updateAutoCheckState();
      }
    },
    openVersionForm(row) {
      // 先重置为空，避免 checkbox-group 残留旧选中状态
      this.versionForm = {
        isEdit: false,
        _id: "",
        model: "",
        version: "",
        cardV: "",
        videoV: "",
        mcuV: "",
        language: "zh",
        ram: "2GB",
        rom: "16GB",
        autoTestKeys: [],
        manualTestKeys: [],
      };
      this.autoCheckAll = false;
      this.isAutoIndeterminate = false;
      this.manualCheckAll = false;
      this.isManualIndeterminate = false;
      // 编辑模式：先填充数据，再打开弹窗，确保 checkbox 正确回显
      if (row) {
        this.versionForm.isEdit = true;
        this.versionForm._id = row.id || row._id;
        this.versionForm.model = row.model;
        this.versionForm.version = row.version;
        this.versionForm.cardV = row.cardV;
        this.versionForm.videoV = row.videoV;
        this.versionForm.mcuV = row.mcuV;
        this.versionForm.language = row.language || "zh";
        this.versionForm.ram = row.ram || "";
        this.versionForm.rom = row.rom || "";
        this.versionForm.autoTestKeys = this.parseKeys(row.autoTestKeys);
        this.versionForm.manualTestKeys = this.parseKeys(row.manualTestKeys);
      }
      // 版本字段为空时，移除对应的自动测试项勾选
      this.syncAutoTestKeysByVersion();
      this.versionFormVisible = true;
      this.$nextTick(() => {
        this.updateAutoCheckState();
        this.updateManualCheckState();
      });
    },
    handleAutoCheckAll(val) {
      const enabledKeys = AUTO_TEST_ITEMS.filter((i) => !this.isAutoItemDisabled(i.key)).map((i) => i.key);
      this.versionForm.autoTestKeys = val ? enabledKeys : [];
      this.isAutoIndeterminate = false;
    },
    handleAutoCheckChange() {
      this.updateAutoCheckState();
    },
    updateAutoCheckState() {
      const enabledKeys = AUTO_TEST_ITEMS.filter((i) => !this.isAutoItemDisabled(i.key)).map((i) => i.key);
      const selectedCount = this.versionForm.autoTestKeys.filter((k) => enabledKeys.includes(k)).length;
      this.autoCheckAll = enabledKeys.length > 0 && selectedCount === enabledKeys.length;
      this.isAutoIndeterminate = selectedCount > 0 && selectedCount < enabledKeys.length;
    },
    handleManualCheckAll(val) {
      this.versionForm.manualTestKeys = val ? MANUAL_TEST_ITEMS.map((i) => i.key) : [];
      this.isManualIndeterminate = false;
    },
    handleManualCheckChange() {
      this.updateManualCheckState();
    },
    updateManualCheckState() {
      const count = this.versionForm.manualTestKeys.length;
      this.manualCheckAll = count === MANUAL_TEST_ITEMS.length;
      this.isManualIndeterminate = count > 0 && count < MANUAL_TEST_ITEMS.length;
    },
    submitVersionForm() {
      this.$refs.versionFormRef.validate((valid) => {
        if (!valid) return;
        // 保存前再同步一次，确保版本字段为空时对应的自动测试项已被移除
        this.syncAutoTestKeysByVersion();
        if (this.versionForm.autoTestKeys.length === 0) {
          this.$message.warning("请至少选择一个自动测试项");
          return;
        }
        const params = {
          model: this.versionForm.model.trim(),
          version: this.versionForm.version.trim(),
          cardV: String(this.versionForm.cardV).trim(),
          videoV: String(this.versionForm.videoV).trim(),
          mcuV: String(this.versionForm.mcuV).trim(),
          language: this.versionForm.language || "zh",
          ram: this.versionForm.ram || "",
          rom: this.versionForm.rom || "",
          autoTestKeys: JSON.stringify(this.versionForm.autoTestKeys),
          manualTestKeys: JSON.stringify(this.versionForm.manualTestKeys),
        };
        this.$http.post("/admin/testRecords/versionSave", params, () => {
          this.$message.success(this.versionForm.isEdit ? "配置更新成功" : "配置添加成功");
          this.versionFormVisible = false;
          this.loadVersionList();
        });
      });
    },
    handleVersionDel(row) {
      this.$confirm(`确认删除型号【${row.model}】的版本配置？`, "提示", {
        type: "warning",
      })
        .then(() => {
          this.$http.post("/admin/testRecords/versionDel", { id: row.id || row._id }, () => {
            this.$message.success("删除成功");
            this.loadVersionList();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.version-list-page {
  width: 100%;
  height: 100%;

  /deep/ .content {
    .center {
      height: 100%;
    }

    .down {
      display: none;
    }
  }

  .layout-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  .header-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    height: 50px;
    padding: 0 8px;
    flex-shrink: 0;

    .page-title {
      font-size: 16px;
      font-weight: bold;
      color: var(--theme-color-customized-1);
      flex: 1;
    }
  }

  .table-wrapper {
    flex: 1;
    min-height: 0;
    padding: 0 8px;
    box-sizing: border-box;
  }
}
</style>

<!-- dialog 使用 append-to-body，内容移到 body 下，scoped 样式无法命中，需用全局样式 -->
<style lang="scss">
.version-form-dialog {
  .form-split {
    display: flex;
    gap: 16px;

    .form-left {
      flex: 0 0 360px;
      display: flex;
      flex-direction: column;
    }

    .form-right {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;

      .el-form-item__label {
        width: 120px !important;
      }
      .el-form-item__content {
        margin-left: 120px !important;
      }
    }
  }

  .test-items-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .checkbox-list {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 16px;
    padding: 8px 12px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fafafa;

    .el-checkbox {
      margin-right: 0;
      width: auto;
    }
  }
}
</style>
